import React, { Component } from 'react';
import { DomCustomImage, DomSelect, DomField, DomBoolCheckbox, DomCheckboxField, DomTextarea } from "../Services/formDOM";
import { checkInput, returnValue, hasValue, validateEmail } from "../Services/Validation";
import "./Body.scss";
import { apiURL, Environment } from "../Services/Base";
import Loading from "../Services/Loading/Loading";
import { GA_Push } from "../Services/GoogleAnalytics";
import { shareFacebook, shareTwitter, openNegishut } from "../Services/Sharing"



Object.filter = function (obj, predicate) {
    var result = {}, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key) && predicate(obj[key])) {
            result[key] = obj[key];
        }
    }

    return result;
};

export default class Body extends Component {
    constructor(props) {
        super();
        this.state = {
            isBusy: false,
            isLoading: false,
            captchaEnable: true,
            ImagePlaceholder: "צרפו תמונה משפחתית מהביקור באתר ( קבצי PNG, JPEG )",
            sendForm: {}

        }
        window.sendCallback = this.sendForm;
    }

    componentDidMount() {
        (() => {
            if (window.document.getElementById("GoogleRecap")) return;

            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = "GoogleRecap";
            script.async = 1;
            script.defer = 1;
            script.src = 'https://www.google.com/recaptcha/api.js';

            document.getElementsByTagName('head')[0].appendChild(script);
        })();

        this.setState({
            captchaEnable: !Environment().isLocalhost
        })
    }
    handleInputChange = (event) => {
        const handleChange = {
            [event.target.name]: {
                ...this.state[event.target.name],
                error: "",
                label: event.target.dataset.label ? event.target.dataset.label : "",
                value: (event.target.dataset && event.target.dataset.bool === "true" ? (this.state[event.target.name].value ? 0 : 1) : event.target.value)
            }
        }
        this.setState(handleChange);
    }
    changeImageLabel = (event) => {
        var allowdExtensions = ["jpg", "jpeg", "gif", "png"];
        var file = event.target.files[0];
        if (file) {
            if (file.size > 5242880) {
                alert("לא ניתן להעלות קבצים מעל 5mb")
                event.target.value = "";
                return false;
            }

            var isAllowd = false;
            allowdExtensions.forEach((extension) => {
                if (file.type.indexOf(extension) > -1) {
                    isAllowd = true;
                }
            })

            if (!isAllowd) {
                // alert("לא ניתן להעלות קבצים מסוג " + file.type);
                alert("אפשר לעלות רק קבצי תמונה");
                event.target.value = "";
                return false;
            }

            this.setState({
                ImagePlaceholder: file.name,
                FamilyImage: {
                    ...this.state.FamilyImage,
                    name: file.name,
                    value: file,
                    label: "",
                    id: "FamilyImage"
                }
            })
        } else {
            return false;
        }
    }

    addState = (stateName, isRequired, stateId) => {
        this.setState({
            [stateName]: {
                name: stateName,
                value: "",
                label: "",
                id: stateId,
                isRequired: !isRequired ? false : true
            }
        })
    }
    setErrorMessage = (target, errorMsg) => {
        if (!this.state[target.name]) return;

        this.setState({
            [target.name]: {
                ...target,
                error: errorMsg
            }
        });


    }



    saveAndValidate = async () => {
        if (this.state.isBusy) return;


        this.setState({
            isLoading: true,
            isBusy: true
        });

        let isError = false,
            j = 0,
            jsonBody = {},
            state = Object.filter(this.state, s => s.isRequired),
            fieldStateKeys = Object.keys(state);


        for (let s in state) {
            if (await !checkInput(state[s], this.setErrorMessage)) isError = true;
            j++;
        }

        for (let k in fieldStateKeys) {
            jsonBody = Object.assign(jsonBody, {
                [fieldStateKeys[k]]: returnValue(state[fieldStateKeys[k]])
            });
        }

        if (isError && j == fieldStateKeys.length) {
            this.setState({
                isLoading: false,
                isBusy: false
            })
            return;
        }



        this.setState({
            jsonBody,
            isLoading: true,
            isBusy: true
        }, () => {
            if (this.state.captchaEnable) {
                window.grecaptcha.execute()
            } else {
                this.sendForm();
            }
        })

    }
    sendForm = async () => {
        let formData = new FormData();
        const { jsonBody } = this.state;

        if (this.state.captchaEnable) {
            window.grecaptcha.reset()
        }

        let isExists = await fetch(`${apiURL}IsExists`, {
            method: 'POST',
            headers: {
                'Content-Type': `application/json`
            },
            body: JSON.stringify(jsonBody)

        }).then(data => data.json());

        if (isExists) {
            this.setState({
                isLoading: false,
                isBusy: false
            })
            this.props.setPage("isExsits");
            return;
        }

        fetch(`${apiURL}Save`, {
            method: 'POST',
            headers: {
                'Content-Type': `application/json`
            },
            body: JSON.stringify(jsonBody)
        }).then(data => data.json())
            .then(data => {
                this.setState({
                    isLoading: false,
                    isBusy: false
                })
                GA_Push("form_sent");
                if (this.state.captchaEnable) {
                    window.grecaptcha.reset();
                }
                this.props.setPage("thankyou");
            }).catch(error => {
                this.setState({
                    isLoading: false,
                    isBusy: false
                });

            });
    }

    render() {
        return (
            <div className="main">
              
                <div className="form-section">

                    <div className="padding">
                        <div className="top">
                            <div className="right">
                                <a href="https://www.ynet.co.il" target="_blank">
                                    <div className="logo-ynet"></div>
                                </a>
                                <div className="split">

                                </div>

                                <div className="logo-center"></div>

                            </div>

                            <div className="left">
                                <div className="icons">
                                    <div className="share-title">שתף</div>
                                    <div onClick={shareTwitter} className="twitter"></div>
                                    <div onClick={shareFacebook} className="facebook"></div>
                                    <div onClick={openNegishut} className="disable-icon"></div>
                                </div>
                            </div>
                        </div>


                        <div className="title-top">

                        </div>

                        <div className="text">
                            <p>
                                בכל יום שישי יש רגע שהוא רק שלך, הרגע הכי נשי שלך.
                            </p>
                            <p>
                                דקות ספורות לפני שהשמש שוקעת את עוצמת את העיניים, מסכמת את השבוע שחלף ומבקשת בריאות,
                            </p>
                            <p>
                                אהבה, הצלחה ובעצם מה לא, מול נרות השבת שזה עתה הדלקת.
                            </p>
                            <p>
                                פרויקט מיוחד של ynet  בשיתוף מרכז מעל"ה מזמין אותך לספר על רגע מיוחד סביב הדלקת הנרות בערב שבת.
                            </p>
                            <p className="text-web"> 
                                 זו יכולה להיות סיטואציה משפחתית מרגשת, תפילה שהתגשמה, אירוע בלתי נשכח,
                            </p>
                            <p className="text-mobile">
                                 זו יכולה להיות סיטואציה משפחתית מרגשת, תפילה שהתגשמה,
                            </p>
                            <p className="text-mobile">אירוע בלתי נשכח, לוקיישן יוצא דופן בו הדלקת נרות או כל  </p>
                            <p className="text-mobile">דבר מיוחד אחר.</p>
                            
                            <p className="text-web" >
                                 לוקיישן יוצא דופן בו הדלקת נרות או כל דבר מיוחד אחר.
                            </p>
                            <p>
                                הסיפורים הנבחרים יהפכו לכתבות בווידיאו או בטקסט באתר ynet .
                            </p>

                            <p className="bottom-text">
                                שניים מהסיפורים המרגשים ביותר יזכו בזוג פמוטי כסף או בזוג פמוטי קריסטל

                            </p>
                            <div className="text-bold">
                            </div>
                        </div>



                        <div className="form">
                            <Loading showLoading={this.state.isLoading} />

                            <div className="tripinfo">
                                <DomTextarea
                                    type="text"
                                    max={3000}
                                    label="מהו הרגע המיוחד שלך?"
                                    placeholder="מהו הרגע המיוחד שלך?"
                                    name="MyMoment"
                                    id="MyMoment"
                                    className="field"
                                    isRequired
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state} />
                            </div>



                            <div className="personinfo">
                                <DomField
                                    type="text"
                                    max={64}
                                    label="שם מלא"
                                    placeholder="שם מלא"
                                    name="FullName"
                                    id="FullName"
                                    className="field"
                                    isRequired
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state} />
                                <DomField
                                    type="tel"
                                    max={3}
                                    label="גיל"
                                    placeholder="גיל"
                                    name="Age"
                                    id="Age"
                                    className="field"
                                    isRequired
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state} />
                                <DomSelect

                                    max={3}
                                    label="מין"
                                    placeholder="מין"
                                    name="Gender"
                                    id="Gender"
                                    className="field"
                                    isRequired
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state} />
                                <DomField
                                    type="email"
                                    max={20}
                                    label='אימייל'
                                    placeholder='אימייל'
                                    name="Email"
                                    id="Email"
                                    className="field"
                                    isRequired
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state} />
                                <DomField
                                    type="tel"
                                    max={10}
                                    label="טלפון"
                                    placeholder="טלפון"
                                    name="PhoneNumber"
                                    id="PhoneNumber"
                                    className="field"
                                    isRequired
                                    onChange={this.handleInputChange}
                                    onLoad={this.addState}
                                    {...this.state} />
                            </div>
                            <div className="bottom">
                                <div className="terms-web">
                                    <DomBoolCheckbox
                                        type="checkbox"
                                        name="Terms"
                                        id="Terms"
                                        className="field"
                                        label={'קראתי, הבנתי, ומסכים  <a href="http://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" title="" target="_blank">לתנאי השימוש</a> , <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" title="" target="_blank">למדיניות הפרטיות</a>  <a href="https://z.ynet.co.il/mShort/commerce/API/NashimMadlikot/takanon.htm" title="" target="_blank">ולתקנון הפעילות</a> ,  וכן נותן הסכמי למשלוח דברי פרסום לפי פרטיי לעיל'}
                                        value="0"
                                        isRequired
                                        onChange={this.handleInputChange}
                                        onLoad={this.addState}
                                        {...this.state}
                                    />
                                </div>
                                <div className="button-section">
                                    <div className="send" onClick={() => {
                                        this.saveAndValidate()
                                    }}>
                                        <div className="text">
                                            שלח
                                            </div>
                                        <div className="g-recaptcha"
                                            data-callback="sendCallback"
                                            data-size="invisible"
                                            data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"></div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/Components/Body/Body.jsx